<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card shaped>
        <v-card-title>
          <v-icon large left color="primary">mdi-cash-register</v-icon>
          <span class="title font-weight-light">Отчёты продаж</span>
        </v-card-title>
        <v-col>
          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header>Немного об отчётах</v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="text-justify mb-1">
                  Клики по рекламным баннерам и товарам. Клики и «проданные с баннера» — живые данные, включая сегодня.
                  «Проданные с баннера» — строки заказов с товаром баннера, а не доказанный клик.
                </p>
                <p class="text-justify mb-0">
                  «Проданные всего» в отчёте «Альтернатива» обновляются раз в сутки ночью; дата актуальности — в шапке файла.
                  Период по умолчанию — последние 30 дней.
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-row class="px-4 pb-4">
          <!-- 1. Клики на баннеры -->
          <v-col cols="12" md="6">
            <v-card outlined class="fill-height">
              <v-card-title class="subtitle-1">Клики на баннеры</v-card-title>
              <v-card-text>
                <v-row dense>
                  <v-col cols="6"><v-text-field v-model="adClicks.dateStart" type="date" label="Дата с"></v-text-field></v-col>
                  <v-col cols="6"><v-text-field v-model="adClicks.dateFinish" type="date" label="Дата по"></v-text-field></v-col>
                </v-row>
                <v-select v-model="adClicks.adId" :items="options.locations" item-text="name" item-value="id"
                  label="Тип баннера" :loading="loading.options" @change="adClicks.adItemContentId = null"></v-select>
                <v-autocomplete v-model="adClicks.adItemContentId" :items="BannersOf(adClicks.adId)"
                  item-text="title" item-value="adItemContentId" label="Баннер" :disabled="adClicks.adId === null"></v-autocomplete>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loading.adClicks" :disabled="!adClicks.adItemContentId"
                  @click="Download('adClicks', 'DOWNLOAD_SALES_REPORTS_AD_CLICKS', AdClicksRequest())">
                  <v-icon left>mdi-microsoft-excel</v-icon>Скачать отчёт
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

          <!-- 2. Альтернатива -->
          <v-col cols="12" md="6">
            <v-card outlined class="fill-height">
              <v-card-title class="subtitle-1">Клики на баннеры Альтернатива</v-card-title>
              <v-card-text>
                <v-row dense>
                  <v-col cols="6"><v-text-field v-model="alternative.dateStart" type="date" label="Дата с"></v-text-field></v-col>
                  <v-col cols="6"><v-text-field v-model="alternative.dateFinish" type="date" label="Дата по"></v-text-field></v-col>
                </v-row>
                <v-autocomplete v-model="alternative.adItemContentId" :items="BannersOf(options.alternativeLocationId)"
                  item-text="title" item-value="adItemContentId" label="Баннер" clearable persistent-hint hint="Пусто — все"
                  :loading="loading.options"></v-autocomplete>
                <v-autocomplete v-model="alternative.goodsId" :items="GoodsOf([options.alternativeLocationId])"
                  item-text="goodsName" item-value="goodsId" label="SKU конкурента" clearable persistent-hint hint="Пусто — все"
                  :loading="loading.options"></v-autocomplete>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loading.alternative"
                  @click="Download('alternative', 'DOWNLOAD_SALES_REPORTS_ALTERNATIVE_CLICKS', Request(alternative))">
                  <v-icon left>mdi-microsoft-excel</v-icon>Скачать отчёт
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

          <!-- 3. Товар дня / Акция от производителя / Товар месяца -->
          <v-col cols="12" md="6">
            <v-card outlined class="fill-height">
              <v-card-title class="subtitle-1">Клики на Товар дня / Акция от производителя / Товар месяца</v-card-title>
              <v-card-text>
                <v-row dense>
                  <v-col cols="6"><v-text-field v-model="promo.dateStart" type="date" label="Дата с"></v-text-field></v-col>
                  <v-col cols="6"><v-text-field v-model="promo.dateFinish" type="date" label="Дата по"></v-text-field></v-col>
                </v-row>
                <v-select v-model="promo.adId" :items="PromoLocations" item-text="name" item-value="id" label="Тип"
                  :loading="loading.options" @change="promo.adItemContentId = null; promo.goodsId = null"></v-select>
                <v-autocomplete v-model="promo.adItemContentId" :items="BannersOf(promo.adId)" item-text="title"
                  item-value="adItemContentId" label="Акция" clearable persistent-hint hint="Пусто — все"
                  :disabled="promo.adId === null"></v-autocomplete>
                <v-autocomplete v-model="promo.goodsId" :items="GoodsOf([promo.adId])" item-text="goodsName"
                  item-value="goodsId" label="SKU" clearable persistent-hint hint="Пусто — все"
                  :disabled="promo.adId === null"></v-autocomplete>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loading.promo" :disabled="promo.adId === null"
                  @click="Download('promo', 'DOWNLOAD_SALES_REPORTS_PROMO_CLICKS', { ...Request(promo), adId: promo.adId })">
                  <v-icon left>mdi-microsoft-excel</v-icon>Скачать отчёт
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

          <!-- 6. Клики по всем баннерам -->
          <v-col cols="12" md="3">
            <v-card outlined class="fill-height">
              <v-card-title class="subtitle-1">Клики по всем баннерам</v-card-title>
              <v-card-text>
                <v-row dense>
                  <v-col cols="6"><v-text-field v-model="allBanners.dateStart" type="date" label="Дата с"></v-text-field></v-col>
                  <v-col cols="6"><v-text-field v-model="allBanners.dateFinish" type="date" label="Дата по"></v-text-field></v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loading.allBanners"
                  @click="Download('allBanners', 'DOWNLOAD_SALES_REPORTS_ALL_BANNERS_CLICKS', Period(allBanners))">
                  <v-icon left>mdi-microsoft-excel</v-icon>Скачать
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

          <!-- 7. Клики по баннерам всех типов (сумма) -->
          <v-col cols="12" md="3">
            <v-card outlined class="fill-height">
              <v-card-title class="subtitle-1">Клики по баннерам всех типов (сумма)</v-card-title>
              <v-card-text>
                <v-row dense>
                  <v-col cols="6"><v-text-field v-model="bannerTypes.dateStart" type="date" label="Дата с"></v-text-field></v-col>
                  <v-col cols="6"><v-text-field v-model="bannerTypes.dateFinish" type="date" label="Дата по"></v-text-field></v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loading.bannerTypes"
                  @click="Download('bannerTypes', 'DOWNLOAD_SALES_REPORTS_BANNER_TYPES_CLICKS', Period(bannerTypes))">
                  <v-icon left>mdi-microsoft-excel</v-icon>Скачать
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// Последние 30 дней по сегодня, как период по умолчанию на бэкенде
function defaultPeriod() {
  const format = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const finish = new Date();
  const start = new Date();
  start.setDate(finish.getDate() - 29);

  return { dateStart: format(start), dateFinish: format(finish) };
}

export default {
  data: () => ({
    options: { locations: [], banners: [], promoLocationIds: [], alternativeLocationId: null },
    adClicks: { ...defaultPeriod(), adId: null, adItemContentId: null },
    alternative: { ...defaultPeriod(), adItemContentId: null, goodsId: null },
    promo: { ...defaultPeriod(), adId: null, adItemContentId: null, goodsId: null },
    allBanners: defaultPeriod(),
    bannerTypes: defaultPeriod(),
    loading: { options: true, adClicks: false, alternative: false, promo: false, allBanners: false, bannerTypes: false },
  }),
  computed: {
    PromoLocations() {
      return this.options.locations.filter((x) => this.options.promoLocationIds.includes(x.id));
    },
  },
  async mounted() {
    this.loading.options = true;
    try {
      this.options = await this.$store.dispatch("SALES_REPORTS_FILTER_OPTIONS");
    } catch (error) {
      window.console.log(error);
    } finally {
      this.loading.options = false;
    }
  },
  methods: {
    BannersOf(adId) {
      return this.options.banners.filter((x) => x.adId === adId);
    },
    // Товары баннеров зон без повторов
    GoodsOf(adIds) {
      const seen = new Set();
      return this.options.banners.filter((x) => {
        if (!adIds.includes(x.adId) || !x.goodsId || seen.has(x.goodsId)) return false;
        seen.add(x.goodsId);
        return true;
      });
    },
    Period(card) {
      return { dateStart: card.dateStart || null, dateFinish: card.dateFinish || null };
    },
    Request(card) {
      return { ...this.Period(card), adItemContentId: card.adItemContentId || null, goodsId: card.goodsId || null };
    },
    // Ad/GetAdClickByContentExcelReportAsync требует обе даты
    AdClicksRequest() {
      const period = { ...defaultPeriod(), ...Object.fromEntries(Object.entries(this.Period(this.adClicks)).filter(([, v]) => v)) };
      return { ...period, adId: this.adClicks.adId, adItemContentId: this.adClicks.adItemContentId };
    },
    async Download(key, action, payload) {
      this.loading[key] = true;
      try {
        await this.$store.dispatch(action, payload);
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading[key] = false;
      }
    },
  },
};
</script>
